import tc from './tc.json';

const translations = {
  tc,
};
export default translations;
